export default class LoginUser {
  constructor() {
    this.appCode = null;
    this.accountId = null;
    this.account = null;
    this.accountName = null;
    this.currentCompanyId = null;
    this.adminTypeEnum = null;
    this.orgTreeType = null;
    /**
     * @type {CompanyInfo[]}
     */
    this.companyInfoList = null;
    /**
     * @type {string[]}
     */
    this.roles = null;
    /**
     * @type {string[]}
     */
    this.permissions = null;
    /**
     * @type {string[]}
     */
    this.buttonCodes = null;
    /**
     * @type {string[]}
     */
    this.resourceUrls = null;

  }
}

export class CompanyInfo {
  constructor() {
    this.companyId = null;
    this.companyNameCn = null;
    this.account = null;
    /**
     * @type {DeptInfo[]}
     */
    this.deptInfoList = null;
  }
}

export class DeptInfo {
  constructor() {
    this.deptId = null;
    this.deptNameCn = null;
    this.companyId = null;
  }
}
